export default __webpack_public_path__ + "static/media/pr_c_10.b0b204c3.jpg";